import { provideHttpClient } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter } from '@angular/router';

import { appRoutes } from './app.routes';
import { EnvironmentResolver } from './core/environment-resolver';
import { DealerFactoryToken, initializeDealerService } from './factories/dealer.factory';
import { WsClientService } from './services/ws-client.service';

const initializeEnvironment = (environmentResolver: EnvironmentResolver) => async (): Promise<void> => {
    await environmentResolver.setEnvironment();
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(appRoutes),
        provideAnimations(),
        provideHttpClient(),
        {
            provide: APP_INITIALIZER,
            useFactory: initializeEnvironment,
            multi: true,
            deps: [EnvironmentResolver]
        },
        {
            provide: DealerFactoryToken,
            useFactory: initializeDealerService,
            deps: [WsClientService]
        }
    ]
};
